<template>
  <b-container class="charter-container pt-3">
    <LoadingIndicator 
      v-if="loading"
      topic="Charter"
    />
    <b-row v-else>
      <b-col>
        <b-card
          class="mb-3 card-title-center"
        >
          <b-card-title
            class="h4"
            title-tag="h1"
            title="Project Charter"
          ></b-card-title>
          <section>
            <p>We, the members of the <span class="font-weight-bold">{{ projectName }} project team</span>, commit to achieving the following project goals:</p>
            <ul
              v-if="hasGoals" 
              :class="goalsColumnCountClass"
            >
              <li 
                v-for="goal in goals"
                :key="goal.goalId"
              >
                {{ goal.name }}
              </li>
            </ul>
            <p 
              v-else
              class="text-center "
            >No goals have been set for this project.</p>
          </section>
          <hr class="my-5">
          <section class="mb-5">
            <h2 class="h5 text-center mb-3">Charter Signees</h2>
            <!-- <ul 
              v-if="hasSignees"
              :class="signeesColumnCountClass"
            >
              <li 
                v-for="signee in signees"
                :key="signee.userId"
              >
                {{ signee.name }}
              </li>
            </ul> -->
            <b-table-lite
              v-if="hasSignees"
              :items="signees"
              :fields="fields"
            />
            <p 
              v-else
              class="text-center"
            >No signees yet.</p>
          </section>          
        </b-card>
        <div class="text-center">
          <b-button
            type="button"
            variant="primary"
            :disabled="isCharterSending || isCharterSent"
            @click="sendCharter"
          >
            <b-spinner v-if="isCharterSending" small label="Spinning" />
            <span v-else-if="isCharterSent">Charter Sent!</span>
            <span v-else>Send Charter to Team Members</span>
          </b-button>
        </div>
        <BaseMessageBlock :messages="uniqueErrors"></BaseMessageBlock>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import ProjectWizardCreateSurvey from "@/components/ProjectWizardCreateSurvey.vue";

export default {
  components: {
    ProjectWizardCreateSurvey
  },
  props: {
    projectName: { type: String, required: true },
    signees: { type: Array, required: true },
  },
  data() {
    return {
      projectId: '',
      goals: [],
      errors: [],
      loading: false,
      sending: false,
      isCharterSending: false,
      isCharterSent: false,
      fields: [
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'approveCharterDate',
          label: 'Date Signed'
        },
      ],
    };
  },
  mounted() {
    this.loading = true;
    this.projectId = this.$route.params.id;
    this.loadGoals();
  },
  methods: {
    loadGoals() {
      axios
        .get(
          `${this.$api_url}/goals/${this.projectId}`,
          this.getReqConfig()
        )
        .then((response) => {
          this.goals = response.data;
        })
        .catch(() => {
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendCharter() {
      this.isCharterSending = true;
      const url = `${this.$api_url}/projects/${this.projectId}/send-charter`;

      axios
        .post(
          url,
          null,
          this.getReqConfig()
        )
        .then(() => {
          // console.log('charter sent successfully');
          this.isCharterSent = true;
          this.$emit('sentCharter')
        })
        .catch((err) => {
          this.errors.push(err);
        })
        .finally(() => {
          this.isCharterSending = false;
        });
    },
    resetSendButton() {
      this.isCharterSent = false;
    }
  },
  computed: {
    uniqueErrors() {
      return Array.from(new Set(this.errors.map(e => e.message))).map(m => ({message: m}));
    },
    goalsColumnCountClass() {
      return this.goals.length >= 4 ? 'column-count-2-sm' : '';
    },
    signeesColumnCountClass() {
      return this.signees.length >= 4 ? 'column-count-2-sm' : '';
    },
    hasGoals() {
      return this.goals.length > 0;
    },
    hasSignees() {
      return this.signees.length > 0;
    },
  }
};
</script>

<style lang="scss" scoped>
.charter-container.container {
  max-width: 736px;
}
.card-title-center .card-title {
  text-align: center;
}
</style>